export const NotificationUrls = {
  new_appraisal: `${location.origin}/avaliacao`,
  new_resale: `${location.origin}/repasse`,
};
